import React from "react";

import { Header } from "../../components/headers/header/header.component";

export const SupportHeader = () => {
  return <Header title="Support" />;
};
